export enum ActionType {
    complianceWithCategoryResolution = 'ComplianceWithCategoryResolution',
    contractExtraction = 'ContractExtraction',
    endorsementFormNumberV1 = 'EndorsementFormNumberCategorizationV1',
    entityNameMatchingV1 = 'EntityNameMatchingV1',
    evaluatedEntityMappingV1 = 'EvaluatedEntityMappingV1',
    nonExtractionCriterionResolutionV1 = 'NonExtractionCriterionResolutionV1',
    aieManuscriptCategorization = 'AdditionalInsuredEndorsementManuscriptCategorization',
    documentDataReview = 'DocumentDataReview',
}
